/* eslint-disable @typescript-eslint/no-explicit-any */
import { ConditionRenderer } from "@/components/shared/condition-renderer";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import { Minus, Plus } from "lucide-react";
import React, { useState } from "react";
import { useDocumentReadOnly } from "../hook/useDocument";

type DocumentCollapsibleProp = {
  children: React.ReactNode;
  label: string;
  className?: string;
  isParent?: boolean;
  review_required?: any;
  updateJsonData?: any;
  pkey?: any;
  originalDetailsData?: any;
};

export const DocumentCollapsible = ({
  children,
  label,
  isParent,
  className,
  review_required,
  updateJsonData,
  // pkey,
  // originalDetailsData,
}: DocumentCollapsibleProp) => {
  const [open, setOpen] = useState(true);
  const isReadOnly = useDocumentReadOnly();
  // const cpath = "domain_json." + pkey + "." + label;
  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className={cn(
        "relative",
        isParent ? "" : "bg-white border",
        "  rounded-xl overflow-hidden",
        className,
      )}
    >
      <CollapsibleTrigger
        className={cn(
          "flex py-3 justify-start gap-3 items-center w-full text-left px-4 font-medium",
          "text-[16px]",
          open ? "border-transparent border-b-slate-200 border-2 " : "",
          isParent ? "bg-white !border-2 rounded-xl border-[#0000001a]" : "",
        )}
      >
        <span className="border rounded-sm p-1">
          <ConditionRenderer condition={open}>
            <Minus strokeWidth={1} size={18} />
            <Plus strokeWidth={1} size={18} />
          </ConditionRenderer>
        </span>
        {label}
      </CollapsibleTrigger>
      {review_required ? (
        <div className="absolute h-[54px] flex items-center justify-center pr-6 right-0 top-0">
          <Button
            className=" py-1 h-auto"
            disabled={isReadOnly}
            onClick={() => updateJsonData()}
          >
            Save Review
          </Button>
        </div>
      ) : (
        ""
      )}
      <CollapsibleContent className={cn("", isParent ? "mt-4" : "p-4 px-4")}>
        {children}
      </CollapsibleContent>
    </Collapsible>
  );
};
